import styled from 'styled-components';

export const PhysicianInfoWrapper = styled.div`
 display: flex;
`;
